import { useCallback, useEffect, useRef, useState } from 'react';
import { MyLink, LinkTheme } from '@app/shared';
import { TypeAccordionMarks, typeMarks } from './types';
import { WrapperTable } from '@sharedUi/WrapperTable';
import { scrollToElement } from '@app/shared/helpers';
import IconArrow from './icons/arrow.svg';
import classNames from 'classnames';
import { useWindowSizing } from '@app/hooks/useSizeWindow';

import styles from './AccordionMarks.module.scss';

export function AccordionMarks({ title, models, active, type = typeMarks.Tires, className }: TypeAccordionMarks) {
  const defaultHref = type === typeMarks.Tires ? '/auto/' : '/auto/disks/';
  const [show, setShow] = useState<boolean>(false);
  const isMobile = useWindowSizing(990);
  const AccordionRef = useRef<HTMLDivElement>();
  const getUrlModel = (model): string => {
    const modelUrl = model.model.toLowerCase();
    return `${defaultHref}${model.codeMark}/${modelUrl}/`;
  };

  const getUrlMark = (markName): string => {
    return `${defaultHref}${markName}/`;
  };

  const handlerOpenAccordion = useCallback(() => {
    setShow(state => !state);
  }, []);

  useEffect(() => {
    if (active) {
      isMobile
        ? AccordionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
        : scrollToElement(AccordionRef.current);
      setShow(true);
    }
  }, [active]);

  return (
    <div ref={AccordionRef} onClick={handlerOpenAccordion} className={classNames(styles.Wrapper, { [styles.hide]: !show }, className)}>
      <div className={styles.Header}>
        <div className={styles.TitleMark}>
          <IconArrow height={18} width={18} />
          <div>{title}</div>
        </div>
        <div className={styles.LinkAllModels}>
          <MyLink href={getUrlMark(models[0]?.codeMark)} themes={isMobile ? LinkTheme.Theme8 : LinkTheme.Theme3}>
            Все {type === typeMarks.Tires ? 'шины' : 'диски'} для <span>{title}</span>
          </MyLink>
        </div>
      </div>
      <WrapperTable classNameRow={styles.LinsModels}>
        {models.map(model => (
          <div className={styles.ContainerModel} key={model.modelsId}>
            <div>
              <MyLink href={getUrlModel(model)} className={styles.Model}>
                {model.model}
              </MyLink>
            </div>
            <div>{`${model.yearB}-${model.yearF}`}</div>
          </div>
        ))}
      </WrapperTable>
    </div>
  );
}
